<template>
  <el-row style="height: 20px; margin-bottom: 10px">
    <el-col :span="24">
      <el-select size="mini" v-model="selectfunc" placeholder="请选择" style="margin-right: 10px;width: 100px; float: left">
        <el-option
            v-for="item in allselectfunc"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-input v-model="search" size="mini" placeholder="输入关键字搜索" style=" width: 500px;margin-bottom:10px; float: left"/>
      <el-button type="primary" size="mini" @click="this.getCustomerCompany();issueDialogVisible = true" style="float:right; height: 28px">新增问题</el-button>
    </el-col>
  </el-row>
  <el-table v-loading="loading" :data="tableData.filter(data => !search ||
  (selectfunc === 'title' && data.title != undefined && data.title.toLowerCase().includes(search.toLowerCase())) ||
  (selectfunc === 'content' && data.content != undefined &&  data.content.toLowerCase().includes(search.toLowerCase())) ||
  (selectfunc === 'solution' && data.solution != undefined && data.solution.toLowerCase().includes(search.toLowerCase())))"
            ref="issueTable"
            @row-dblclick="handleOpen"
            :row-class-name="tableRowClassName"
            @filter-change="filterChange"
            :default-sort ="{prop:'urgencyID',order:'descending'}"
            height="95%"
            style="width: 100%;">
<!--    <el-table-column prop="collection" width="80">-->
<!--      <template #default="scope">-->
<!--        <div class="block">-->
<!--          <el-rate v-model="scope.row.companyID"></el-rate>-->
<!--        </div>-->
<!--      </template>-->
<!--    </el-table-column>-->
    <el-table-column prop="issueid" label="编号" width="80" sortable>
    </el-table-column>
    <el-table-column prop="urgencyID" label="优先级" width="100" sortable>
      <template #default="scope">
        <el-tag v-for="item in allurgency.filter(function(item, index, arr) {
            return scope.row.urgencyID === item.value})"
            :key="item.value"
            effect="dark"
            :color="item.color"
            :value="item.label"
            style="border-color: white;border-radius: 20px">
          {{item.label}}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column prop="identifier" label="问题编号" width="100" sortable>
    </el-table-column>
    <el-table-column prop="companyID" label="公司" width="150"
                     column-key="companyID"
                     :filters=allusercompany
                     :filter-method="filterCompanyID"
                     filter-placement="bottom-end">
      <template #default="scope">
        <span v-for="item in allusercompany.filter(function(item, index, arr) {
            return scope.row.companyID === item.value})"
              :key="item.value">{{item.text}}</span>
      </template>
    </el-table-column>
    <el-table-column prop="title" label="标题" width="auto">
    </el-table-column>
    <el-table-column prop="type" label="类型" width="100"
                     column-key="type"
                     :filters="alltype.filter(function(item, index, arr) {
            return filteredCompany.includes(item.companyID)})"
                     :filter-method="filterType"
                     filter-placement="bottom-end">
      <template #default="scope">
        <el-select v-model="scope.row.type" size="mini" placeholder="请选择" style="width:80px;"
                   v-on:change="typechange(scope.row,scope.row.type)">
          <el-option v-for="item in alltype.filter(function(item, index, arr) {
            return scope.row.companyID === item.companyID})"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </template>
    </el-table-column>
    <el-table-column prop="customer" label="客户" width="120"
      column-key="customer"
      :filters="allcustomercompany.filter(function(item, index, arr) {
            return filteredCompany.includes(item.companyID)})"
      :filter-method="filterCustomer"
      filter-placement="bottom-end">
    </el-table-column>
    <el-table-column prop="submittime" label="提交时间" width="200" sortable>
    </el-table-column>
    <el-table-column prop="service" label="客服" width="120">
    </el-table-column>
    <el-table-column prop="status" label="完成状态" width="120"
                     column-key="status"
                     :filters=allstatus
                     :filter-method="filterStatus"
                     :filtered-value="['open']"
                     filter-placement="bottom-end">
    </el-table-column>
<!--    <el-table-column label="操作" width="150">-->
<!--      <template #default="scope">-->
<!--        &lt;!&ndash;              <el-button&ndash;&gt;-->
<!--        &lt;!&ndash;                  size="mini"&ndash;&gt;-->
<!--        &lt;!&ndash;                  @click.stop="handleEdit(scope.$index, scope.row)">编辑</el-button>&ndash;&gt;-->
<!--        <el-button-->
<!--            size="mini"-->
<!--            type="danger"-->
<!--            @click.stop="handleDelete(scope.$index, scope.row)">删除</el-button>-->
<!--      </template>-->
<!--    </el-table-column>-->
  </el-table>
  <el-drawer
      title="ISSUE"
      v-model="drawer"
      :before-close="handleClose"
      destroy-on-close>
    <div class="demo-drawer__content">
      <el-descriptions :title="issue.title" direction="vertical" :column="1">
        <el-descriptions-item label="创建时间" >
          <template #label>创建时间
          </template>{{issue.submittime}}
        </el-descriptions-item>
        <el-descriptions-item label="优先级">
          <el-radio-group v-model="issue.urgency" :fill="urgencycolor" @change="urgencychange" style="float: left">
            <el-radio-button v-for="item in allurgency"
                             :key="item.value"
                             :label="item.label">
            </el-radio-button>
          </el-radio-group>
        </el-descriptions-item>
        <el-descriptions-item label="问题内容" >
          <el-input
              type="textarea"
              :rows="8"
              placeholder="请输入内容"
              v-model="issue.content"
              @change="changeissue">
          </el-input>
        </el-descriptions-item>
        <el-descriptions-item label="解决方案" >
          <el-input
              type="textarea"
              :rows="8"
              placeholder="请输入解决方案"
              v-model="issue.solution"
              @change="changeissue">
          </el-input>
        </el-descriptions-item>
        <el-descriptions-item label="备注">
          <el-input
              type="textarea"
              :rows="8"
              placeholder="请输入备注"
              v-model="issue.note"
              @change="changeissue">
          </el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <el-switch
              style="display: block; width: fit-content"
              v-model="issue.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="statuschange(issue.$index, issue,issue.status)"
              active-value="close"
              inactive-value="open"
          >
          </el-switch>
        </el-descriptions-item>
      </el-descriptions>
      <!--          <div class="demo-drawer__footer">-->
      <!--            <el-button @click="cancelForm">取 消</el-button>-->
      <!--            <el-button type="primary" @click="drawer = false" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}</el-button>-->
      <!--          </div>-->
    </div>
  </el-drawer>
  <el-dialog
      title="新增问题"
      v-model="issueDialogVisible"
      width="70%"
      :before-close="issueDialogClose">
    <el-form :rules="rules" ref="form" :model="form" label-width="80px">
      <el-form-item label="公司" prop="companyID">
        <el-col :span="8">
          <el-select v-model="form.companyID" placeholder="请选择问题所属公司" @change="companyChange(form.companyID)">
            <el-option v-for="item in allusercompany"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title"  type="text" placeholder="请输入问题标题" maxlength="255" show-word-limit style="width: 50%;float: left;" ></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-col :span="8">
          <el-select v-model="form.type" placeholder="请选择问题类型" no-data-text="无可选类型">
            <el-option v-for="item in alltype.filter(function(item, index, arr) {
            return form.companyID === item.companyID})"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item label="客户" prop="customerid" v-show="customerVisible">
        <el-col :span="8">
          <el-select v-model="form.customerid"
                     filterable
                     allow-create
                     no-data-text="无可选客户，请输入"
                     placeholder="请选择或输入客户姓名" >
            <el-option v-for="item in allcustomercompany.filter(function(item, index, arr) {
            return form.companyID === item.companyID})"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item label="内容" prop="content">
        <el-input type="textarea" v-model="form.content" placeholder="请输入问题内容"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="note">
        <el-input type="textarea" v-model="form.note" placeholder="请输入备注"></el-input>
      </el-form-item>
      <el-form-item label="优先级" prop="urgency">
        <el-radio-group v-model="form.urgency" :fill="urgencyradiocolor" @change="urgencyRadioChange" style="float: left">
          <el-radio-button v-for="item in allurgency"
                           :key="item.value"
                           :label="item.label">
          </el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item style="text-align: left">
        <el-button type="primary" @click="onSubmit('form')">确 定</el-button>
        <el-button @click="issueDialogVisible = false">取 消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>

  <div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="this.params.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="this.params.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.total"
      >
      </el-pagination>
  </div>
</template>

<script>
import {
  showData,
  addRowIssue,
  changeurgency,
  changeissue,
  deleteIssue,
  getallcustomer,
  getalltype, getallurgency, getcustomercompany,
  getDemo, getusercompany, insertcustomercompany,
  updStatus, getallrole
} from "../../axios";
import Axios from "axios";

export default {
  name: "issue",
  props:['userid','username','realname','role','companyID','usercompany'],
  data(){
    // const item = {
    //   id: 'MAC237',
    //   title: '问题1',
    //   customer: 'Cherry',
    //   submittime: '2014/1/1 8:00',
    //   service: 'Sophia',
    //   status: '进行中'
    // };
    return {
      selectfunc: 'title',
      allurgency: [{
        label: '一般',
        value: 0,
        color: '#67C23A'
      },{
        label: '次要',
        value: 1,
        color: '#409EFF'
      },{
        label: '重要',
        value: 2,
        color: '#E6A23C'
      },{
        label: '严重',
        value: 3,
        color: '#F56C6C'
      }],
      allselectfunc: [{
        label: '标题',
        value: 'title'
      },{
        label: '内容',
        value: 'content'
      },{
        label: '解决方案',
        value: 'solution'
      }],
      filteredCompany: [],
      allusercompany: [],
      allcustomer: [], //具有账号的客户
      allcustomercompany: [], //所有客户
      allstatus: [{
        text: 'open',
        value: 'open'
      },{
        text: 'close',
        value: 'close'
      }],
      allrole:[],
      alltype: [{
        text: '技术',
        label: '技术',
        value: '技术'
      },{
        text: '财务',
        label: '财务',
        value: '财务'
      }],
      issue: null, //单个问题
      //tableData: Array(20).fill(item),
      form: { //新增问题
        title: '',
        type: '',
        customerid: '',
        content: '',
        note: '',
        companyID: '',
        urgency: ''
      },
      rules: {
        title: [
          {required: true, message: '请输入问题标题', trigger: 'blur'}
        ],
        type: [
          {required: true, message: '请选择问题类型', trigger: 'change'}
        ],
        companyID: [
          {required: true, message: '请选择公司', trigger: 'change'}
        ],
        customerid: [
          {required: true, message: '请输入客户', trigger: 'blur'}
        ],
        content: [
          {required: true, message: '请输入问题内容', trigger: 'blur'}
        ]
      },
      tableData: [],

      total:'',
      params: {
        page: 1,
        size: 10,
      },
      // tableData: [{
      //   issueid: 'MAC237',
      //   title: '问题1',
      //   type: '财务',
      //   customer: 'Cherry',
      //   submittime: '2014/1/1 8:00',
      //   service: 'Sophia',
      //   status: 'open',
      //   content: 'xxxxxxxxxxxxxxx',
      //   solution: 'xxxxxxxxxxxxxxx',
      //   note: 'xxxxxxxxxxxxxxx',
      //   companyID: 1
      // },{
      //   issueid: 'MAC237',
      //   title: '问题2',
      //   type: '财务',
      //   customer: 'Cherry',
      //   submittime: '2014/1/1 8:00',
      //   service: 'Sophia',
      //   status: 'open',
      //   content: 'xxxxxxxxxxxxxxx',
      //   solution: 'xxxxxxxxxxxxxxx',
      //   note: 'xxxxxxxxxxxxxxx',
      //   companyID: 1
      // },{
      //   issueid: 'MAC237',
      //   title: '问题3',
      //   type: '财务',
      //   customer: 'Cherry',
      //   submittime: '2014/1/1 9:00',
      //   service: 'Sophia',
      //   status: 'open',
      //   content: 'xxxxxxxxxxxxxxx',
      //   solution: 'xxxxxxxxxxxxxxx',
      //   note: 'xxxxxxxxxxxxxxx',
      //   companyID: 1
      // },{
      //   issueid: 'MAC237',
      //   title: '问题4',
      //   type: '财务',
      //   customer: 'Cherry',
      //   submittime: '2015/1/1 8:00',
      //   service: 'Sophia',
      //   status: 'open',
      //   content: 'xxxxxxxxxxxxxxx',
      //   solution: 'xxxxxxxxxxxxxxx',
      //   note: 'xxxxxxxxxxxxxxx',
      //   companyID: 1
      // },{
      //   issueid: 'MAC237',
      //   title: '问题5',
      //   type: '财务',
      //   customer: 'Cherry',
      //   submittime: '2016/1/1 8:00',
      //   service: 'Sophia',
      //   status: 'open',
      //   content: 'xxxxxxxxxxxxxxx',
      //   solution: 'xxxxxxxxxxxxxxx',
      //   note: 'xxxxxxxxxxxxxxx',
      //   companyID: 1
      // }
      // ],
      drawer: false, //右边抽屉
      formLabelWidth: '80px',
      search: '',
      issueDialogVisible: false,
      typeDialogVisible: false,
      customerVisible: false,
      loading: true,
      urgencyradiocolor: '#409EFF', //新增问题中优先级按钮颜色
      urgencycolor: '#409EFF'  //抽屉中新增问题优先级按钮
    }
  },
  created() {
    this.updatetable();
    this.getAllType();
    this.getUserCompany();
    this.getAllUrgency();
    this.getallrole();
    this.getCustomerCompany();
    //this.showData();
  },

  mounted() {
   this.pagehelper();
  },
  methods:{     //issue分页问题测试1
    getAllCustomer(){
      getallcustomer().then(res=>{
        this.allcustomer = res.data;
        // console.log(res);
      }).catch(err=>{
        console.log(err);
      });
    },
    getAllUrgency(){  //获得所有优先级信息
      getallurgency().then(res=>{
        this.allurgency.splice(0,this.allurgency.length);
        for (let i=0 ;i<res.count;i++) {
          this.allurgency.push({
            text: res.data[i].label,
            label: res.data[i].label,
            value: res.data[i].id,
            color: res.data[i].color
          });
        }
        // console.log(res);
      }).catch(err=>{
        console.log(err);
      });
      if(this.allurgency.length>0){
        this.form.urgency = this.allurgency[0].label;
        this.urgencyradiocolor = this.allurgency[0].color;
      }
    },
    getCustomerCompany(){ //得到用户公司所有的客户姓名
      getcustomercompany({companyID: this.companyID}).then(res=>{
        this.allcustomercompany.splice(0,this.allcustomercompany.length);
        for (let i=0 ;i<res.count;i++) {
          this.allcustomercompany.push({
            text: res.data[i].name,
            label: res.data[i].name,
            value: res.data[i].name,
            companyID: res.data[i].companyID
          });
        }
        this.allcustomercompany.sort(function(a,b){
          if(typeof a.label=="string" && typeof b.label == "string"){
          return a.label.localeCompare(b.label);
          }
        }); //将公司根据公司名排序
        // console.log(res);
      }).catch(err=>{
        console.log(err);
      });
    },
    getAllType(){ //获得所有问题类型
      getalltype().then(res=>{
        this.alltype.splice(0,this.alltype.length);
        for (let i=0 ;i<res.count;i++){
          this.alltype.push({
            text: res.data[i].name,
            label: res.data[i].name,
            value: res.data[i].type,
            companyID: res.data[i].companyID
          });
        }
        // console.log(res);
      }).catch(err=>{
        console.log(err);
      });
    },
    getUserCompany(){ //获得用户的公司信息
      getusercompany({
        companyID: this.companyID
      }).then(res=>{
        this.allusercompany.splice(0,this.allusercompany.length);
        for (let i=0 ;i<res.count;i++){
          this.allusercompany.push({text: res.data[i].companyname,label: res.data[i].companyname,value: res.data[i].companyID});
        }
        this.allusercompany.sort(function(a,b){return a.label>b.label ? 1:-1;}); //将公司根据公司名排序
        // console.log(res);
      }).catch(err=>{
        console.log(err);
      });
    },
    filterStatus(value, row) { //筛选状态
      return row.status === value;
    },
    filterType(value, row) { //筛选类型
      return row.type === value;
    },
    filterCompanyID(value, row) { //筛选公司
      return row.companyID === value;
    },
    filterCustomer(value, row) { //筛选客户
      return row.customer === value;
    },
    filterChange(filters){
      if(filters.companyID != undefined){
        this.filteredCompany = filters.companyID;
        if(this.filteredCompany.length == 0)
          this.$refs.issueTable.clearFilter('type');
      }
    },
    changeissue(value){  //修改问题内容，解决方案以及备注
      changeissue(this.issue).then(res=>{
        // console.log(res);
      }).catch(err=>{
        console.log(err);
      });

    },
    onSubmit(formName){  //新增问题
      if(this.customerVisible === false){
        this.form.customerid = this.realname;
      }
      let urgencyID;
      for(let i=0;i<this.allurgency.length;i++){  //获得优先级ID
        if(this.allurgency[i].label === this.form.urgency){
          urgencyID = this.allurgency[i].value;
          break;
        }
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addRowIssue({
            'type': this.form.type,
            'title': this.form.title,
            'content': this.form.content,
            'note': this.form.note,
            'customer': this.form.customerid,
            'companyID': this.form.companyID,
            'urgencyID': urgencyID
          }).then(res=>{
            this.$message.success(res);
            this.issueDialogVisible = false;
            this.form.content = '';
            this.form.note = '';
            this.form.type = '';
            this.form.title = '';
            this.form.companyID = '';
            this.form.customerid = '';
            this.customerVisible = false;
            this.updatetable();
          }).catch(err=>{
            console.log(err);
          });
          let isnewcustomer = true;
          for (let i = 0;i<this.allcustomercompany.length;i++){
            if(this.allcustomercompany[i].value == this.form.customerid
                && this.allcustomercompany[i].companyID == this.form.companyID) {
              isnewcustomer = false;
              break;
            }
          }
          if (isnewcustomer){
            insertcustomercompany({
              name: this.form.customerid,
              companyID: this.form.companyID
            }).then(res=>{
              // console.log(res);
            }).catch(err=>{
              console.log(err);
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    updatetable(){  //重新获取表格数据
      this.loading = true;
      //this.showData();
      this.pagehelper();
      getDemo({
        companyID: this.companyID
      }).then(res=>{
        // console.log(res);
        this.tableData = res.data;
        this.loading = false;
      }).catch(err=>{
        console.log(err);
      });
    },
    statuschange(index, row, status){ //状态改变
      if(row.issueid != undefined && row.issueid != '' && status != undefined && status != ''){
        updStatus({
          issueid: row.issueid,
          status: status
        }).then(res=>{
          // console.log(res);
        }).catch(err=>{
          console.log(err);
        })
      }
    },
    companyIDchange(row, value){
      for(let i=0;i<this.alltype.length;i++){
        if(this.alltype[i].companyID === row.companyID){
          row.type = this.alltype[i].value;
          break;
        }
      }
      changeissue(row).then(res=>{
        // console.log(res);
      }).catch(err=>{
        console.log(err);
      });
    },
    typechange(row,value){ //改变问题类型
      changeissue(row).then(res=>{
        // console.log(res);
      }).catch(err=>{
        console.log(err);
      });
    },
    urgencychange(label){
      for (let i=0;i<this.allurgency.length;i++){
        if(label === this.allurgency[i].label) {
          this.issue.urgencyID = this.allurgency[i].value;
          this.urgencycolor = this.allurgency[i].color;
          break;
        }
      }
      changeurgency({
        issueid: this.issue.issueid,
        urgencyID: this.issue.urgencyID
      }).then(res=>{
        // console.log(res);
      }).catch(err=>{
        console.log(err);
      });
      // console.log(this.issue);
    },
    urgencyRadioChange(label){  //新增问题中优先级按钮的修改
      for (let i=0;i<this.allurgency.length;i++){
        if(label === this.allurgency[i].label) {
          this.urgencyradiocolor = this.allurgency[i].color;
          break;
        }
      }
    },
    handleOpen(val){  //打开抽屉
      this.drawer = true;
      let thisRowData =this;
      thisRowData = val;
      this.issue = thisRowData;
      for (let i=0;i<this.allurgency.length;i++){  //渲染优先级按钮组
        if(this.issue.urgencyID === this.allurgency[i].value) {
          this.urgencycolor = this.allurgency[i].color;
          this.issue.urgency = this.allurgency[i].label;
          break;
        }
      }
    },
    handleClose() { //关闭抽屉
      this.drawer = false;
    },
    issueDialogClose(){  //关闭新增对话框
      this.issueDialogVisible = false;
    },
    handleEdit(index, row) { //编辑按钮
      console.log(index, row);
    },
    handleDelete(index, row) { //删除按钮
      deleteIssue({
        issueid: row.issueid
      }).then(res=>{
        // console.log(res);
        this.updatetable();
      }).catch(err=>{
        console.log(err);
      });
    },
    tableRowClassName({row,rowIndex}) {
      if (row.status === 'close') {
        return 'success-row';
      } else {
        return 'warning-row';
      }
    },
    companyChange(companyID){
      this.form.type='';
      this.form.customerid='';
      let i=0;
      for(;i<this.usercompany.length;i++){
        if(this.usercompany[i].companyID === companyID &&
            (this.usercompany[i].roleID === this.allrole.find(item => item.label==='管理员').value ||
            this.usercompany[i].roleID === this.allrole.find(item => item.label==='客服').value)){
          this.customerVisible = true;
          break;
        }
      }
      if(i===this.usercompany.length)
        this.customerVisible = false;
    },
    getallrole(){  //得到所有角色信息
      getallrole().then(res =>{
        this.allrole = res.data;
      }).catch(err =>{
        console.log(err);
      })
    },
    /** 
    showData(){
      showData(+ this.params.page + "/" + this.params.size).then(Response =>{
        console.log(Response.tableData);
        const { list, total } =Response.data;
        this.tableData = list;
        this.total = total;
      }).catch(err => {
        console.error(err);
      });
    },*/

    pagehelper:function(){  //这里标记  666
           this.$axios
      .get("http://localhost:8080/issue/pages/" + this.params.page + "/" + this.params.size)
      .then((res) => {
        // console.log(res.data);
        this.datas = res.data.list;
        this.total = res.data.total;
      });
    },

    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.params.size = val;
      //this.showData();
      this.pagehelper();
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.params.page = val;
      //this.showData();
      this.pagehelper();
    }

  }
}
</script>

<style>
/*修复问题标题输入框长度限制与输入字符重叠*/
.el-input__inner,[maxlength] {
  padding-right: 60px;
}

.el-table .success-row{
  background-color: #f0f9eb;
}

.el-table .warning-row{
  background-color: oldlace;
}

.warning-row:hover > td{
  background-color: #FDE9C3 !important;
}

.success-row:hover > td{
  background-color: #D9F9C8 !important;
}

.el-drawer__body{
  overflow-y: scroll;
}

/*修改滚动条样式*/
div ::-webkit-scrollbar{
  width:10px;
  height:10px;
  /**/
}
div ::-webkit-scrollbar-track{
  background: rgb(239, 239, 239);
  border-radius:2px;
}
div ::-webkit-scrollbar-thumb{
  background: #bfbfbf;
  border-radius:10px;
}
div ::-webkit-scrollbar-thumb:hover{
  background: #333;
}
div ::-webkit-scrollbar-corner{
  background: #179a16;
}

</style>
